import React from 'react';
import {Button, Checkbox, IconButton, styled} from '@mui/material';
import Grid from "@mui/material/Grid";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";

interface ImagePickerProps {
  imageList: string[];
  setImageList: (imageList: string[]) => void;
  setSelectedUrl: (url: string) => void;
  selectedUrl: string;
  handleUploadImage: (file: File) => Promise<{ src: string; type: string; }[]>
}

export const ImagePicker = ({
                              imageList,
                              setImageList,
                              setSelectedUrl,
                              selectedUrl,
                              handleUploadImage
                            }: ImagePickerProps) => {
  const handleDeleteImage = (url: string, index: number) => {
    const listTemp = [...imageList]
    listTemp.splice(index, 1)
    setImageList(listTemp)
    if (selectedUrl === url) {
      setSelectedUrl("")
    }
  }

  if (imageList.length === 0) {
    const handleUploadFile = async (file: File | null) => {
      if (file) {
        const results = await handleUploadImage(file)
        const link = results[0]?.src
        setImageList([link])
        setSelectedUrl(link)
      }
    }

    return (
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon/>}
      >
        Загрузить обложку
        <VisuallyHiddenInput
          type="file"
          onChange={(event) => handleUploadFile(event.target.files?.[0] || null)}
          multiple
        />
      </Button>
    )
  }

  return (
    <Grid container gap={1}>
      {imageList.map((url, index) => (
        <Grid item xs={4}
              key={index}
              position="relative"
              sx={{
                transition: "all .1s linear",
                border: selectedUrl === url ? '2px solid #1976d2' : '1px solid #ccc',
                borderRadius: 2,
                overflow: 'hidden',
                cursor: 'pointer',
              }}
              onClick={() => setSelectedUrl(url)}
        >
          <img
            src={url}
            alt={`preview-${index}`}
            style={{width: '100%', display: 'block', height: 'auto'}}
          />
          <Checkbox
            checked={selectedUrl === url}
            color="secondary"
            sx={{
              position: 'absolute',
              top: 8,
              left: 8,
            }}
            readOnly
          />
          <IconButton
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              handleDeleteImage(url, index)
            }}><DeleteIcon/></IconButton>
        </Grid>
      ))}
    </Grid>
  );
};


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
